import React, { Component } from 'react';
import i from '../imports';
import navigation from '../navigation';
import ContainerDimensions from 'react-container-dimensions';
import Dimensions from 'react-dimensions';
import Session from '../services/session'

const IconStyle = {

    color: "#FF5563",
    fontSize: 18,
    fontWeight: "bold",
    align:"left",
    paddingTop: "4px"
}

const TextStyle = {
    align:"left",
    fontSize: 18,
}


class TourShortInfo extends Component {


    constructor(props) {
        super(props);
   }

    render() {

        let tour = this.props.data;
        return (
            <i.PureGridProvider>
                <i.Container >
                    <i.Row style={{paddingTop: "6px"}}>
                        <i.Col xs={2} style={IconStyle} >
                            <i.Icon icon={i.faIcons.mapMarker} size="32"/>
                        </i.Col>
                        <i.Col xs={10} style={TextStyle} align="left">
                           {
                               tour.relation_destinations.map(m => `${Session.model.destinationPages.filter(f => f.name == m.destinationpages)[0].translations[0].title} `)
                           }
                        </i.Col>
                    </i.Row>
                    <i.Row >
                        <i.Col xs={2} style={IconStyle} >
                            <i.Icon icon={i.faIcons.clockO} size="32"/>
                        </i.Col>
                        <i.Col xs={10} style={TextStyle} align="left">
                           {
                               `${tour.days} ${Session.model.common.words.days} \ ${(parseInt(tour.days) - 1)} ${Session.model.common.words.nights}`
                           }
                        </i.Col>
                    </i.Row>
                    <i.Row >
                        <i.Col xs={2} style={IconStyle}>
                            <i.Icon icon={i.faIcons.hotel} size="32"/>
                        </i.Col>
                        <i.Col xs={10} style={TextStyle} align="left">
                           {tour.translations[0].accomodation_info}
                        </i.Col>
                    </i.Row>
                    <i.Row >
                        <i.Col xs={2} style={IconStyle}>
                            <i.Icon icon={i.faIcons.calendar} size="32"/>
                        </i.Col>
                        <i.Col xs={10} style={TextStyle} align="left">
                            {tour.translations[0].season_info}
                        </i.Col>
                    </i.Row>
                </i.Container>
            </i.PureGridProvider>
        );
    }
}

export default TourShortInfo;